import { useContext, useState } from "react";
import useTranslator from "../../../hooks/useTranslator";
import LandLordContext from "../../../context/landlord/LandLordContext";
import { useNavigate, useParams } from "react-router-dom";
import { toast, haveValue } from "../../../helper/common";

const AddIdealistaProperty = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const { bringPropertiesKelify } = useContext(LandLordContext);
  const [username, setUsername] = useState("");
  const [bringPropertiesLoading, setBringPropertiesLoading] = useState(false);

  const handleBringProperty = async (e) => {
    e.preventDefault();
    try {
      setBringPropertiesLoading(true);
      const payload = {
        username_url: username,
      };
      const res = await bringPropertiesKelify(payload);
      if (res.status === "success") {
        setUsername("");
        toast.success(res?.imported + " " + _t("propertiesImported"));
        navigate(haveValue(workspaceId) ? `/${workspaceId}/home` : `/home`);
      } else {
        toast.error(
          res?.response?.data?.message ?? _t("failedToImportProperties")
        );
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ?? _t("failedToImportProperties")
      );
    } finally {
      setBringPropertiesLoading(false);
    }
  };
  const [activeTab, setActiveTab] = useState("url");

  return (
    <div className="main-page-wrapper idealist-main profileRequestWrapper">
      <div className="addidealist-comp">
        <div className="addidealist-comp-header">
          <h2>{_t("addPropertiesAndGetStarted")}</h2>
          <p>{_t("noPropertiesHasBeenAddedyet")}</p>
        </div>
        <div className="addidealist-comp-content">
          <form
            onSubmit={handleBringProperty}
            className="addidealist-comp-content-modal"
          >
            <div className="d-flex align-items-center addidealist-comp-content-header">
              <img src="/images/idealista-icon.svg" alt="" />
              <div>
                <h2>{_t("bringYourPropertyFromIdealista")}</h2>
                <p>{_t("noPropertiesHasBeenAddedyet")}</p>
              </div>
            </div>
            <div className="addidealist-comp-content-header-tabs">
              <div
                onClick={() => setActiveTab("url")}
                className={`addidealist-comp-content-header-tab ${
                  activeTab === "url" &&
                  "addidealist-comp-content-header-active-tab"
                }`}
              >
                <img src="/images/link-icon.svg" alt="" />
                <h2>{_t("importByUrl")}</h2>
              </div>
              <div
                onClick={() => setActiveTab("agency")}
                className={`addidealist-comp-content-header-tab ${
                  activeTab === "agency" &&
                  "addidealist-comp-content-header-active-tab"
                }`}
              >
                <img src="/images/building-icon.svg" alt="" />
                <h2>{_t("importByAgency")}</h2>
              </div>
            </div>
            <div className="forminput customInput mb-0">
              <label className="forminput label-text">
                <h6 className="modal-label">
                  {" "}
                  {activeTab === "url" ? _t("usernameOrUrl") : _t("agencyName")}
                </h6>
              </label>
              <input
                type="text"
                name="email"
                className="form-control modal-input"
                placeholder={
                  activeTab === "url"
                    ? _t("enterUsernameOrURL")
                    : _t("enterAgencyName")
                }
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <button
              disabled={bringPropertiesLoading}
              type="submit"
              className="cursor-pointer btnNext"
            >
              {bringPropertiesLoading
                ? _t("importingProperties")
                : _t("bringProperty")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddIdealistaProperty;
